import { Maybe } from 'types/FMSGraphqlTypes'
import { TCarrierLoadTypePreference } from '../types'

export const getLoadTypesLabels = (
  loadingCapability: Maybe<TCarrierLoadTypePreference>
): string => {
  const { isDropCapable, isLiveCapable, isPowerOnly } = loadingCapability || {}
  return [
    ...(isDropCapable ? ['Drop'] : []),
    ...(isLiveCapable ? ['Live'] : []),
    ...(isPowerOnly ? ['Power Only'] : []),
  ].join(', ')
}
